import Dropdown from './dropdown'
import PageLayout from './page-layout'
import PermissionsConfig from './permissions-config'
import TurboContainer from './turbo-container'

const prefix = 'sl-'

// add elements here to initialize
const elements = {
  [`${prefix}dropdown`]: Dropdown,
  [`${prefix}page-layout`]: PageLayout,
  [`${prefix}permissions-config`]: PermissionsConfig,
  'turbo-container': TurboContainer
}

for (const key in elements) {
  if (!window.customElements.get(key)) {
    window.customElements.define(key, elements[key])
  }
}
